import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router';

const Details = () => {
    const { id } = useParams()
    const [state, setstate] = useState([])
    useEffect(() => {
        fetch('../port.json').then(res => res.json()).then(data => setstate(data))

    }, [])
    let pr = state.find(pro => pro.key === id)
    console.log(pr);
    // const { name, img1, img2, img3, img, descript, stack } = pr

    return (
        <Container fluid>
            <div className="Title mb-5">
                <h3>{pr?.name}
                    <span> Details</span>
                </h3>

            </div>
            <Container className='c cb'>
                <Row className='my-4'>
                    <img src={pr?.img} alt="" className='img-fluid ' />

                </Row>
                <Row>
                    <Col xs={12} md={3} lg={4}>
                        <img src={pr?.img1} alt="" className='img-fluid' height='850px' />
                    </Col>
                    <Col xs={12} md={3} lg={4}>
                        <img src={pr?.img2} alt="" className='img-fluid ' />
                    </Col>
                    <Col xs={12} md={3} lg={4}>
                        <img src={pr?.img3} alt="" className='img-fluid ' />
                    </Col>
                </Row>
                <Row className='my-5'>
                    <div className="my-5">
                        <h3 className='text-primary'>Technologies :</h3>
                        <span>{pr?.stack}</span>
                    </div>
                    <p>{pr?.descript}</p>
                </Row>
            </Container>
        </Container>
    );
};

export default Details;